var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.message)?_c('div',{class:_setup.blockClasses},[(_setup.currentStatus === _setup.STATUS.PENDING)?_c(_setup.VACIcon,{attrs:{"name":"alert"}}):_vm._e(),(_setup.currentStatus !== _setup.STATUS.PENDING)?_c('div',{staticClass:"vac-notification-status__dot"}):_vm._e(),_vm._v(" "+_vm._s(_setup.message)+" ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }